import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "k-link k-menu-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_down_button = _resolveComponent("drop-down-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_drop_down_button, {
      id: "ddbCurrency",
      items: _ctx.dataItems,
      text: _ctx.selectedCurrency,
      onItemclick: _ctx.onCurrencySelect,
      "button-class": "btn-currency",
      "fill-mode": "outline"
    }, {
      itemRender: _withCtx(({props}) => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(props.item), 1)
      ]),
      _: 1
    }, 8, ["items", "text", "onItemclick"])
  ]))
}